"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGame = void 0;
var react_1 = require("react");
var game_api_1 = require("@l2p/game-api");
var apps_shared_1 = require("@l2p/apps-shared");
var useGame = function (winData) {
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    return (0, react_1.useMemo)(function () {
        var _a, _b, _c;
        if (!winData || ((_a = Object.keys(breakpoints)) === null || _a === void 0 ? void 0 : _a.length) === 0)
            return null;
        if (breakpoints.mobile)
            return (_b = winData === null || winData === void 0 ? void 0 : winData.game) === null || _b === void 0 ? void 0 : _b[game_api_1.GameDeviceTypeEnum.Mobile];
        return (_c = winData === null || winData === void 0 ? void 0 : winData.game) === null || _c === void 0 ? void 0 : _c[game_api_1.GameDeviceTypeEnum.Desktop];
    }, [winData, breakpoints]);
};
exports.useGame = useGame;
